import { useState, useEffect } from 'react';
import { api } from '../lib/api';

interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  is_active: boolean;
}

// Force rebuild: 2025-10-07T17:45:00Z
export const useOrganizationUsers = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response = await api.get<User[] | { count: number; results: User[] }>('/api/users-list/');
        // Handle both direct array and paginated responses
        const userData = Array.isArray(response.data) 
          ? response.data 
          : (response.data && 'results' in response.data ? response.data.results : []);
        setUsers(userData || []);
      } catch (err) {
        setError('Failed to load users');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return { users, loading, error };
};